// carousel.js — Vor/Zurück-Knöpfe für .vc-carousel (Wischen und Tastatur kommen vom Browser über scroll-snap).
//   <div class="vc-carousel" data-label="Fotos"><div class="vc-carousel-track" tabindex="0" role="region" aria-label="Fotos">…items…</div></div>
//   initCarousels(root) ist idempotent; die Knöpfe werden erst bei Bedarf (Zeigergerät, Überlauf) sichtbar.
import { reducedMotion } from '../core/dom.js';

/** Index des nächsten Elements, dessen linke Kante jenseits der aktuellen Position liegt (dir 1) bzw. davor (dir -1). */
export function stepTarget(lefts, scrollLeft, dir, eps = 4) {
  if (dir > 0) { const i = lefts.findIndex((l) => l > scrollLeft + eps); return i < 0 ? lefts.length - 1 : i; }
  for (let i = lefts.length - 1; i >= 0; i--) if (lefts[i] < scrollLeft - eps) return i;
  return 0;
}

function icon(n) { const i = document.createElement('span'); i.className = 'vc-icon'; i.setAttribute('aria-hidden', 'true'); i.textContent = n; return i; }

export function initCarousels(root = document, { prevLabel = 'Zurück', nextLabel = 'Weiter' } = {}) {
  for (const c of root.querySelectorAll('.vc-carousel:not([data-ready])')) {
    const track = c.querySelector('.vc-carousel-track');
    if (!track) continue;
    c.dataset.ready = '';
    const mk = (cls, label, ic) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'vc-icon-btn vc-carousel-nav ' + cls; b.setAttribute('aria-label', label); b.tabIndex = -1;
      b.appendChild(icon(ic)); c.appendChild(b); return b;
    };
    const prev = mk('is-prev', prevLabel, 'chevron_left'), next = mk('is-next', nextLabel, 'chevron_right');
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const go = (dir) => {
      const items = [...track.children];
      const pad = parseFloat(getComputedStyle(track).scrollPaddingInlineStart) || 0;
      const lefts = items.map((it) => it.offsetLeft - track.offsetLeft - pad);
      const i = stepTarget(lefts, track.scrollLeft, dir);
      track.scrollTo({ left: Math.max(0, lefts[i]), behavior: reducedMotion() ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', sync, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    sync();
  }
}
